<template>
  <div class="app-download-widget">
    <div>
      <h1 class="app-download-widget--h1">Get the App</h1>
      <p class="app-download-widget--p">Manage your services anytime, anywhere</p>
    </div>

    <div test-id="phone-wrapper"><img src="./assets/small.png" alt="Phone" class="phone" /></div>

    <div class="store-links">
      <LsClickable
        track-id="app_download_widget-apple_app_store"
        class="store-link"
        @click="
          openUrl({
            url: 'https://itunes.apple.com/us/app/lawnstarter/id968630246?mt=8',
          })
        "
      >
        <img src="./assets/app-store.svg" alt="apple app store" test-id="store" />
      </LsClickable>
      <LsClickable
        track-id="app_download_widget-google_play_store"
        class="store-link"
        @click="
          openUrl({
            url: 'https://play.google.com/store/apps/details?id=com.lawnstarter.lawnstarter&hl=en',
          })
        "
      >
        <img src="./assets/google-play.svg" alt="google play store" />
      </LsClickable>
    </div>
  </div>
</template>

<script>
import { LsClickable } from '@/components/common';

export default {
  name: 'AppDownloadWidget',
  components: {
    LsClickable,
  },
  methods: {
    openUrl({ url }) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-download-widget {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  text-align: center;
}

.app-download-widget--h1 {
  font-size: 3rem;
  margin-bottom: 6px;
}

.app-download-widget--p {
  color: $primary;
  font-size: $size-6;
  margin-bottom: 30px;
}

.phone {
  width: 70%;
  margin-bottom: 20px;
}

.store-links {
  display: flex;
  justify-content: center;
}

.store-link {
  padding: 0 5px;
}

@media (max-width: $mobile-max-width) {
  .app-download-widget {
    border: none;
  }
}

@media (min-width: $desktop) {
  .app-download-widget {
    border: 1px solid $primary-light;
  }
}
.themed-app {
  .app-download-widget--p {
    color: $theme-color-primary;
    font-size: $theme-txt-body-sm;
  }
  @media (min-width: $desktop) {
    .app-download-widget {
      border-color: $theme-color-primary-light;
    }
  }
}
</style>
